import {ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {NavigationService} from '../services/ionic/navigation.service';
import {AuthService} from '../services/auth.service';
import {routeUrls} from '../constants/route-urls';

export const unlockedGuard: CanActivateFn | CanActivateChildFn = async (activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): Promise<boolean> => {
  const authService: AuthService = inject(AuthService);
  const navigationService: NavigationService = inject(NavigationService);

  const isUnlocked: boolean = await authService.isUnlocked;

  if (isUnlocked) {
    return true;
  } else {
    navigationService.navigateRootBack(routeUrls.lockscreen).catch((err: any): void => {
      throw err;
    });

    return false;
  }
};
